module.exports = __webpack_public_path__ + "static/media/signage-indoor-img60.a7a3afd5.jpg";